module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-5-cfc86f569ae28ec42b6309893b5571a7.jpg";